import React from "react";
import { Container, H2, Img, Section, Span } from "../../Styles/Global.Styled";
import shoppingCartFlowers from "../../assets/Icons/shoppingCartFlowers.png";
import contractQoute from "../../assets/Icons/contractQoute.png";
import reviewOrder from "../../assets/Icons/reviewOrder.png";
import deliveryTruck from "../../assets/Icons/deliveryTruck.png";
import LineArrow from "../Arrows/LineArrow";
import { css } from "styled-components";

const sectionStyle = css`
  align-items: center;
  padding: 10vh 3vw 15vh 3vw;
  gap: 4vh;
`;

const imgContainer = css`
  border: 4px solid ${({ theme }) => theme.main};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  padding: 0.5vh;
  height: 8vh;
  width: 8vh;
`;
const imgContainerMb = css`
  height: 7vh;
  width: 7vh;
`;
const imgSize1 = css`
  height: 5vh;
  width: 5vh;
`;

const spanlabel = css`
  font-size: 1.5vh;
  position: absolute;
  bottom: -2vh;
  white-space: nowrap;
`;
const spanLabelMb = css`
  white-space: wrap;
  text-align: center;
  bottom: -4.5vh;
`;

const colFlex = css`
  flex-direction: column;
`;
const centerAlign = css`
  align-items: center;
`;

const ProcessStep = ({ icon, label }) => (
  <Container $baseStyle={colFlex && centerAlign}>
    <Container $baseStyle={imgContainer} $mStyle={imgContainerMb}>
      <Img alt="icon" src={icon} $baseStyle={imgSize1} />
    </Container>
    <Span $baseStyle={spanlabel} $mStyle={spanLabelMb}>
      {label}
    </Span>
  </Container>
);

const ProcessSection = () => {
  const steps = [
    { icon: shoppingCartFlowers, label: "Add Products" },
    { icon: contractQoute, label: "Request a Quote" },
    { icon: reviewOrder, label: "Review Quote" },
    { icon: deliveryTruck, label: "Accept & Ship" },
  ];

  return (
    <Section id="company-process" $baseStyle={sectionStyle}>
      <H2>Our Process</H2>
      <Container $baseStyle={centerAlign}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <ProcessStep {...step} />
            {index < steps.length - 1 && (
              <LineArrow direction="right" style={{ width: "5vh" }} />
            )}
          </React.Fragment>
        ))}
      </Container>
    </Section>
  );
};

export default ProcessSection;
